export default "__VITE_ASSET__DZw40Yuf__"